import { Reducer } from 'redux';
import { ColetaNoCdState, IActionTypesColetaNoCd } from './types';

const INITIAL_STATE: ColetaNoCdState = {
  data: [],
  error: false,
  loading: false,
  filter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<ColetaNoCdState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IActionTypesColetaNoCd.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case IActionTypesColetaNoCd.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case IActionTypesColetaNoCd.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case IActionTypesColetaNoCd.FILTER_COLETACD:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case IActionTypesColetaNoCd.SORTER_COLETACD:
      return {
        ...state,
        sorter: action.payload.sorter,
      };
    case IActionTypesColetaNoCd.CLEAN_COLETANOCD:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
